import type {
  FinanceAdjustmentIndex,
  FinanceChargeKind,
  FinanceContractStatus,
  FinancePaymentMethod,
} from "../types";

// Closed sets mirroring the CHECK constraints of the finance tables. Their labels
// are translated under crm.finance.*.

export const FINANCE_CONTRACT_STATUSES: FinanceContractStatus[] = [
  "active",
  "paused",
  "cancelled",
];

export const FINANCE_CHARGE_KINDS: FinanceChargeKind[] = [
  "recurring",
  "setup",
  "one_off",
];

export const FINANCE_PAYMENT_METHODS: FinancePaymentMethod[] = [
  "pix",
  "boleto",
  "transfer",
  "card",
  "other",
];

export const FINANCE_ADJUSTMENT_INDEXES: FinanceAdjustmentIndex[] = [
  "none",
  "ipca",
  "igpm",
  "fixed",
];

/** Expense categories; an unknown value stored in the database is shown as is */
export const FINANCE_EXPENSE_CATEGORIES = [
  "infrastructure",
  "payroll",
  "tools",
  "taxes",
  "marketing",
  "accounting",
  "other",
] as const;

/** Builds SelectInput choices whose labels are translation keys */
export const toChoices = (values: readonly string[], prefix: string) =>
  values.map((id) => ({ id, name: `${prefix}.${id}` }));

export const paymentMethodChoices = toChoices(
  FINANCE_PAYMENT_METHODS,
  "crm.finance.payment_methods",
);

export const expenseCategoryChoices = toChoices(
  FINANCE_EXPENSE_CATEGORIES,
  "crm.finance.expenses.categories",
);
